const LOGOS = [
  { src: "/assets/logo-siu.png", alt: "Symbiosis International University, Pune", h: 34 },
  { src: "/assets/logo-ascl.png", alt: "Asian School of Cyber Laws", h: 30 },
  { src: "/assets/logo-qmul-ink.png", alt: "Queen Mary University of London", h: 30 },
  { src: "/assets/logo-ropesgray.com.png", alt: "Ropes & Gray LLP", h: 30 },
  { src: "/assets/logo-seedlegals.com.png", alt: "SeedLegals", h: 30 },
  { src: "/assets/logo-lawseek.ai.png", alt: "LawSeek", h: 30 },
];

const Row = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    {LOGOS.map((l) => (
      <span key={l.alt} className="marquee-logo" title={l.alt}>
        <img src={l.src} alt={l.alt} style={{ height: l.h, width: "auto", display: "block" }} />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="marquee-band" data-testid="marquee-band" aria-label="Education and work: Symbiosis International University, Asian School of Cyber Laws, Queen Mary University of London, Ropes and Gray, SeedLegals, LawSeek">
    <div className="marquee-track">
      <Row />
      <Row />
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
